import { memo } from 'react';

function AddIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="19"
			fill="none"
			viewBox="0 0 18 19"
			{...props}
		>
			<path fill="#fff" stroke="#C6C6C6" d="M.5.797h17v17H.5z"></path>
			<path
				stroke="#444"
				strokeWidth="1.5"
				d="M4.281 9.297h9.438M9 4.578v9.437"
			></path>
		</svg>
	);
}

export default memo(AddIcon);
